import { use } from 'react'
import { LanguageContext, type LanguageValue } from './language-context'

export function useLanguage(): LanguageValue {
  const value = use(LanguageContext)
  if (!value) throw new Error('useLanguage는 LanguageProvider 안에서만 쓴다')
  return value
}

/** 문구만 필요한 자리가 대부분이라 짧은 길을 함께 둔다. */
export function useMessages() {
  return useLanguage().messages
}
